import {
  canGetFwsedLayoutPages,
  canGetTaskLayoutPages,
  canGetRiskLayoutPages,
  canGetAuditControlLayoutPages,
  canGetFindingLayoutPages,
  canGetOrganizationSettingsPage,
  isAccountTypeSystem,
  isAdminOrOwnerOfAnyWorkpace,
  isLoggedIn,
  isNotLoggedIn,
  isOrganizationSelected,
} from "@/route-authorization";
import loader from "@/router/loader";
import forbidden from "@c/forbidden";
import PageNotFound from "@c/not-found";

const loadedRoutes = loader();

function prepareChildren(moduleName, ruleProps = [], dynamicRules = () => []) {
  return (loadedRoutes[moduleName] || []).map((i) => {
    const meta = i.meta ?? { rules: [] };
    i.meta = { ...meta, rules: [...meta.rules, ...ruleProps, ...(dynamicRules(i.path) ?? [])] };
    return i;
  });
}
export default [
  {
    path: "/fwsed",
    name: "fwsed",
    component: () => import("@/layouts/fwsed"),
    children: [...prepareChildren("fwsed", [isLoggedIn, isOrganizationSelected, canGetFwsedLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetFwsedLayoutPages] },
  },
  {
    path: "/task",
    name: "task",
    component: () => import("@/layouts/task"),
    children: [...prepareChildren("task", [isLoggedIn, isOrganizationSelected, canGetTaskLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetTaskLayoutPages] },
  },
  {
    path: "/risk",
    name: "risk",
    component: () => import("@/layouts/risk"),
    children: [...prepareChildren("risk", [isLoggedIn, isOrganizationSelected, canGetRiskLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetRiskLayoutPages] },
  },

  {
    path: "/audit-control",
    name: "Audit Control",
    component: () => import("@/layouts/audit-control"),
    children: [...prepareChildren("auditControl", [isLoggedIn, isOrganizationSelected, canGetAuditControlLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetAuditControlLayoutPages] },
  },
  {
    path: "/finding",
    name: "Finding",
    component: () => import("@/layouts/finding"),
    children: [...prepareChildren("finding", [isLoggedIn, isOrganizationSelected, canGetFindingLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetFindingLayoutPages] },
  },

  {
    path: "/",
    name: "platform",
    component: () => import("@/layouts/dashboard/platform"),
    children: [...prepareChildren("platform", [isLoggedIn])],
    meta: { rules: [isLoggedIn] },
  },

  {
    path: "/management",
    name: "management",
    component: () => import("@/layouts/management"),
    children: [...prepareChildren("management", [isLoggedIn, isAccountTypeSystem])],
    meta: { rules: [isLoggedIn, isAccountTypeSystem] },
  },
  {
    path: "/organization",
    name: "organization",
    component: () => import("@/layouts/organization"),
    children: [...prepareChildren("organization", [isLoggedIn, canGetOrganizationSettingsPage])],
    meta: { rules: [isLoggedIn, canGetOrganizationSettingsPage] },
  },
  {
    path: "/account",
    name: "account",
    component: () => import("@/layouts/account"),
    children: [...prepareChildren("account", [isLoggedIn])],
    meta: { rules: [isLoggedIn] },
  },
  {
    path: "/workspace",
    name: "workspace",
    component: () => import("@/layouts/workspace"),
    children: [
      ...prepareChildren("workspace", [isLoggedIn], (path) => {
        return [isAdminOrOwnerOfAnyWorkpace];
        //}
      }),
    ],
    meta: { rules: [isLoggedIn] },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/modules/core/account/login-view"),
    meta: { rules: [isNotLoggedIn] },
  },
  {
    path: "/mail",
    name: "mail",
    component: () => import("@/modules/core/mail-log/mail"),
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("@/modules/core/account/forgot-password-view"),
  },
  {
    path: "/reset-password/:token",
    name: "Reset password",
    component: () => import("@/modules/core/account/reset-password-view"),
  },
  {
    path: "/activation/:token",
    name: "activation",
    component: () => import("@/modules/core/account/activation-view"),
  },

  {
    path: "/logout",
    name: "logout",
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/modules/core/account/register-view"),
  },
  {
    path: "/403",
    component: forbidden,
  },
  {
    path: "*",
    component: PageNotFound,
  },
];
